import { Box, Card, CardContent, Typography } from "@mui/material";

type NoContentCardProps = {
  title: string;
  description: string;
};

const NoContentCard = ({ title, description }: NoContentCardProps) => {
  return (
    <Box
      sx={{
        paddingLeft: 3,
        paddingRight: 3,
        marginTop: 2,
      }}
    >
      <Card variant="outlined">
        <CardContent>
          <Typography variant="body1">{title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default NoContentCard;
